const isIosDevice = () => {
	const userAgent = navigator.userAgent;

	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

const isAndroidDevice = () => {
	const userAgent = navigator.userAgent;

	return /android/i.test(userAgent);
};

const isDeviceTypeMobile = () => {
	const userAgent = navigator.userAgent;

	return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
		userAgent,
	);
};

const getBrowserDetails = () => {
	const ua = navigator.userAgent;
	let tem;
	let M =
		ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
		[];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return `IE ${tem[1] || ''}`;
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
		if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
	}
	M = M[2] ? [M[1], M[2]] : ['-'];
	const versionMatch = ua.match(/version\/(\d+)/i);
	if (versionMatch) {
		M.splice(1, 1, versionMatch[1]);
	}
	return M.join(' ');
};

export { isIosDevice, isAndroidDevice, isDeviceTypeMobile, getBrowserDetails };
